// News.jsx
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Container } from 'react-bootstrap'

import Breadcrumbs from './../block/Breadcrumbs'
import TestimonialsSection from './../block/TestimonialsSection'
import FAQSection from './../block/FAQSection'
import NewsSlider from './../block/NewsSlider'

export default class News extends Component {
  constructor(props) {
    super(props)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return false;
  }

  render() {
    const { data, ajax_data, user_profile_type } = this.props

    return (
      <>
        <Breadcrumbs items={ajax_data.breadcrumbs} />
        
        <NewsSlider news={ajax_data.news || []} pagetitle={ajax_data?.pagetitle} />

        <TestimonialsSection
          page_data={data?.page_data || {}}
          feedback={ajax_data?.feedback_ng || []}
          feedback_legal={ajax_data?.feedback_ng_legal || []}
          user_profile_type={user_profile_type}
        />
        <FAQSection
          qwestions={user_profile_type == `legal` ? ( ajax_data?.qwestions_ng_legal || [] ) : ( ajax_data?.qwestions_ng || [] )}
        />
      </>
    )
  }
}

News.propTypes = {
  data: PropTypes.object,
  ajax_data: PropTypes.object,
  user_profile_type: PropTypes.string
}